/**
 * Atributos de atendimento do cabeçalho da NSMP (preenchidos pelo inspetor).
 * Fonte única do modal da NSMP, da digitação e dos critérios de procedimento de digitação.
 * Formato `{ id, nome }` (DefaultSelectV2); `descricao` é o rótulo longo, quando o curto não basta.
 */
export const EQUIPES_NSMP = [
  { id: 'DUPLA', nome: 'Dupla' },
  { id: 'TRIO', nome: 'Trio' },
  { id: 'PESADA', nome: 'Pesada' },
  { id: 'LINHA_VIVA', nome: 'Linha Viva' },
  { id: 'PODA', nome: 'Poda' },
  { id: 'FAIXA', nome: 'Faixa' },
];

/** `E` (emergência) não é o mesmo que `1`. */
export const PRIORIDADES_NSMP = [
  { id: 'E', nome: 'E', descricao: 'Emergência' },
  { id: '1', nome: '1' },
  { id: '2', nome: '2' },
  { id: '3', nome: '3' },
  { id: '4', nome: '4' },
];

export const ACESSOS_NSMP = [
  { id: 'FACIL', nome: 'Fácil' },
  { id: 'MEDIO', nome: 'Médio' },
  { id: 'DIFICIL', nome: 'Difícil' },
];

/** Ids como string: é o que o DefaultSelectV2 devolve. */
export const ACESSO_VEICULO_NSMP = [
  { id: 'true', nome: 'Sim' },
  { id: 'false', nome: 'Não' },
];

export const rotuloNsmp = (opcoes, id) =>
  opcoes.find((opcao) => String(opcao.id) === String(id))?.nome;
